import { JoonUIColor, SPACING, Typography } from "@joonapp/web-shared"
import { useState } from "react"
import { useTranslation } from "react-i18next"

import useMobile from "../../../hooks/useMobile"
import {
  useCoinCulumativeStatsThisWeekQuery,
  useFamilyQuery,
} from "../../../networking/queries"
import { FamilyQuerySelect } from "../../../types"
import { useCoinTransactionsModalStore } from "../../family/coinTransactions/useTransactionsModalStore"

const TotalCoinsEarnedCard = ({ childId }: { childId: number }) => {
  const [isHovered, setIsHovered] = useState(false)
  const [isPressed, setIsPressed] = useState(false)
  const { onOpen: openCoinTransactionModal } = useCoinTransactionsModalStore()
  const { data: children } = useFamilyQuery(FamilyQuerySelect.CHILDREN)
  const child = children?.find((child) => child.user.id === childId)
  const { data: coinStats, isLoading: isLoadingCoinStats } =
    useCoinCulumativeStatsThisWeekQuery(child?.user.id!)
  const isMobile = useMobile()
  const { t } = useTranslation()

  return (
    <button
      onClick={() => openCoinTransactionModal(child?.user)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => {
        setIsHovered(false)
        setIsPressed(false)
      }}
      onMouseDown={() => setIsPressed(true)}
      onMouseUp={() => setIsPressed(false)}
      className="w-full"
    >
      <div
        className={`w-full flex flex-row items-center p-3 rounded-md border border-borderPrimary`}
        style={{
          justifyContent: isMobile ? "space-between" : "flex-start",
          gap: isMobile ? SPACING.space2 : "160px",
          background: isHovered
            ? JoonUIColor.background.xlightGray
            : JoonUIColor.background.primaryNeutral,
          cursor: isHovered ? "pointer" : "default",
          transition: "background 0.1s ease-in-out",
          transform: isPressed ? "translateY(1px)" : "translateY(0px)",
        }}
      >
        <div className="flex flex-col items-start ">
          <div className="flex flex-row items-center gap-1">
            <img
              className="h-3 w-3"
              src="/images/icons/coin-icon.png"
              alt="coin"
            />
            <Typography variant="bodyBold">
              {child?.user.coins.toLocaleString()}
            </Typography>
          </div>
          <Typography
            variant="bodySmall"
            textAlign="left"
            style={{
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
          >
            {t("REWARD_TOTAL_BALANCE")}
          </Typography>
        </div>
        <div className="flex flex-col items-start">
          <div className="flex flex-row items-center gap-1">
            <img
              className="h-3 w-3"
              src="/images/icons/coin-icon.png"
              alt="coin"
            />
            <Typography variant="bodyBold">
              {isLoadingCoinStats ? "-" : coinStats?.coins_earned}
            </Typography>
          </div>
          <Typography
            variant="bodySmall"
            textAlign="left"
            style={{
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
          >
            {t("REWARD_EARNED_7_DAYS")}
          </Typography>
        </div>
      </div>
    </button>
  )
}

export default TotalCoinsEarnedCard
